import React, { useState } from 'react';
import { Text, Button, Input, VStack, useToast } from '@chakra-ui/react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { careerApi } from './careerApi';
import { AuthShell } from './Signup';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const toast = useToast();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) return toast({ title: 'Password must be ≥ 8 chars', status: 'warning' });
    setBusy(true);
    try {
      await careerApi.resetPassword({ token: params.get('token'), password });
      setDone(true);
    } catch (err) {
      toast({ title: 'Failed', description: err.message, status: 'error' });
    }
    setBusy(false);
  }

  if (done) return <AuthShell title="Password reset"><Text mb="12px" color="#4A5568">You can now log in with the new password.</Text><Button as={Link} to="/login" w="full" bg="#3730A3" color="white" _hover={{ bg: '#312E81' }}>Log in</Button></AuthShell>;

  return (
    <AuthShell title="Set a new password">
      <form onSubmit={submit}>
        <VStack spacing="12px" align="stretch">
          <Input placeholder="New password (≥ 8 chars)" size="md" type="password" required value={password} onChange={e => setPassword(e.target.value)} />
          <Button type="submit" bg="#3730A3" color="white" _hover={{ bg: '#312E81' }} isLoading={busy}>Reset</Button>
        </VStack>
      </form>
    </AuthShell>
  );
}
